// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Divider,
//   Grid,
//   TextField,
//   MenuItem,
//   Select,
//   InputLabel,
//   FormControl,
// } from "@mui/material";

// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import staffService from "../../Services/staffService";
// import roleService from "../../Services/roleService";

// const AddEditStaff = () => {
//   const [staffData, setDoctorData] = useState({
//     full_name: "",
//     role: "",
//     date_of_birth: "",
//     gender: "",
//     contact_number: "",
//     email: "",
//     address: "",
//     qualification: "",
//     hire_date: "",
//     salary: 0.0,
//     cnic: "",
//     status: "1",
//   });

//   const { id } = useParams();
//   const navigate = useNavigate();
//   const [roleData, setRoleData] = useState([]);

//   useEffect(() => {
//     const getRoles = async () => {
//       try {
//         const response = await roleService.fetchAllRoles();
//         console.log(response); // Log the response to confirm the structure
//         setRoleData(response.roles); // Access the patients array within response
//       } catch (error) {
//         toast.error("Error fetching Doctors");
//       }
//     };
//     getRoles();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setDoctorData({ ...staffData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       if (id) {
//         await staffService.update(id, staffData);
//         toast.success("Doctor updated successfully!"); // Success message
//       } else {
//         await staffService.create(staffData);
//         // Success message
//       }
//       navigate("/admin/hospital/doctor");
//       toast.success("Doctor added successfully!"); // Redirect after submission
//     } catch (error) {
//       toast.error("Error saving Doctor."); // Error message
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="w-[90%] m-auto">
//       <h1 className="m-[30px] text-center font-[700] text-[20px]">
//         {id ? "Edit Staff" : "Add Staff"}
//       </h1>
//       <Divider />
//       <div>
//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Name"
//               variant="outlined"
//               fullWidth
//               name="full_name"
//               value={staffData.full_name}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Phone No."
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="contact_number"
//               value={staffData.contact_number}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="CNIC"
//               variant="outlined"
//               fullWidth
//               name="cnic"
//               value={staffData.cnic}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Date of Birth"
//               variant="outlined"
//               fullWidth
//               type="date"
//               name="date_of_birth"
//               value={staffData.date_of_birth}
//               onChange={handleChange}
//               required
//               InputLabelProps={{
//                 shrink: true,
//               }}
//             />
//           </div>

//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Email"
//               variant="outlined"
//               fullWidth
//               name="email"
//               value={staffData.email}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "33%" }}>
//             <TextField
//               label="Qualification"
//               variant="outlined"
//               fullWidth
//               name="qualification"
//               value={staffData.qualification}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "50%" }}>
//             <TextField
//               label="Address"
//               variant="outlined"
//               fullWidth
//               name="address"
//               value={staffData.address}
//               onChange={handleChange}
//               required
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <TextField
//               label="Pay"
//               variant="outlined"
//               fullWidth
//               type="number"
//               name="salary"
//               value={staffData.salary}
//               onChange={handleChange}
//               required
//             />
//           </div>
//         </div>

//         <div className="mt-[20px] flex">
//           <div style={{ width: "33%" }}>
//             <TextField
//               label="Date of Appointment"
//               variant="outlined"
//               fullWidth
//               type="date"
//               name="hire_date"
//               value={staffData.hire_date}
//               onChange={handleChange}
//               required
//               InputLabelProps={{
//                 shrink: true,
//               }}
//             />
//           </div>
//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <FormControl fullWidth>
//               <InputLabel>Assigned Role</InputLabel>
//               <Select
//                 label="Assigned Role"
//                 name="role"
//                 value={staffData.role} // Set the selected doctor's ID
//                 onChange={handleChange}
//                 required
//               >
//                 {roleData.map((roles) => (
//                   <MenuItem key={roles.role_id} value={roles.role_id}>
//                     {roles.role_name}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </div>

//           <div style={{ marginLeft: 20, width: "50%" }}>
//             <FormControl fullWidth>
//               <InputLabel>Gender</InputLabel>
//               <Select
//                 label="Gender"
//                 name="gender"
//                 value={staffData.gender}
//                 onChange={handleChange}
//                 required
//               >
//                 <MenuItem value="Male">Male</MenuItem>
//                 <MenuItem value="Female">Female</MenuItem>
//                 <MenuItem value="Other">Other</MenuItem>
//               </Select>
//             </FormControl>
//           </div>
//         </div>

//         <Grid container style={{ justifyContent: "center", marginTop: "30px" }}>
//           <Button
//             variant="contained"
//             type="submit"
//             color="primary"
//             size="large"
//             className="!bg-gray-700 !text-white"
//             style={{ borderRadius: "10px" }}
//           >
//             Save and Continue
//           </Button>
//         </Grid>
//       </div>
//     </form>
//   );
// };

// export default AddEditStaff;

import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import staffService from "../../Services/staffService";
import roleService from "../../Services/roleService";

const AddEditStaff = () => {
  const [staffData, setStaffData] = useState({
    full_name: "",
    role: "",
    date_of_birth: "",
    gender: "",
    contact_number: "",
    email: "",
    address: "",
    qualification: "",
    hire_date: "",
    salary: "",
    cnic: "",
    status: "1",
  });

  const [roleData, setRoleData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const getRoles = async () => {
      try {
        const response = await roleService.fetchAllRoles();
        setRoleData(response.roles);
      } catch (error) {
        toast.error("Error fetching roles");
      }
    };
    getRoles();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStaffData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      if (id) {
        await staffService.update(id, staffData);
        toast.success("Staff updated successfully!");
      } else {
        await staffService.create(staffData);
        toast.success("Staff added successfully!");
      }
      navigate("/admin/hospital/staff");
    } catch (error) {
      toast.error("Error saving staff.");
    } finally {
      setLoading(false);
    }
  };

  // ── Shared styles — identical to AddEditDispenser ─────────────────────────
  const inputClass =
    "w-full px-3 py-2 text-sm text-gray-800 bg-white border border-gray-200 rounded-lg placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition";

  const labelClass =
    "block text-xs font-medium text-gray-500 uppercase tracking-wide mb-1.5";

  return (
    <div className="p-3 sm:p-6 font-sans">
      {/* ── Page Header — same pattern as AddEditDispenser ── */}
      <div className="mb-6">
        <p className="text-xs font-medium tracking-widest uppercase text-gray-500">
          {id ? "Edit Staff" : "Add Staff"}
        </p>
        <p className="text-xs text-gray-400 mt-0.5">
          {id
            ? "Update the staff member details below."
            : "Fill in the details to onboard a new staff member."}
        </p>
      </div>

      {/* ── Card: Personal Information ── */}
      <div className="border border-gray-200 rounded-xl overflow-hidden mb-4">
        {/* Card Header */}
        <div className="bg-[#215187] px-4 py-3">
          <p className="text-[12px] text-gray-100 font-medium uppercase tracking-wide">
            Personal Information
          </p>
        </div>

        {/* Card Body */}
        <div className="bg-white px-4 py-5 sm:px-6 sm:py-6">
          {/* Row 1 — Name, Phone, CNIC */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <div>
              <label className={labelClass} htmlFor="full_name">
                Name
              </label>
              <input
                id="full_name"
                type="text"
                name="full_name"
                placeholder="Full name"
                value={staffData.full_name}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="contact_number">
                Phone No.
              </label>
              <input
                id="contact_number"
                type="tel"
                name="contact_number"
                placeholder="e.g. 03001234567"
                value={staffData.contact_number}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="cnic">
                CNIC
              </label>
              <input
                id="cnic"
                type="text"
                name="cnic"
                placeholder="e.g. 42101-1234567-1"
                value={staffData.cnic}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
          </div>

          {/* Row 2 — DOB, Email, Qualification */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
            <div>
              <label className={labelClass} htmlFor="date_of_birth">
                Date of Birth
              </label>
              <input
                id="date_of_birth"
                type="date"
                name="date_of_birth"
                value={staffData.date_of_birth}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="email">
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                placeholder="email@example.com"
                value={staffData.email}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="qualification">
                Qualification
              </label>
              <input
                id="qualification"
                type="text"
                name="qualification"
                placeholder="e.g. MBBS, B.Sc Nursing"
                value={staffData.qualification}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
          </div>

          {/* Row 3 — Address, Pay */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className={labelClass} htmlFor="address">
                Address
              </label>
              <input
                id="address"
                type="text"
                name="address"
                placeholder="Street, City, Province"
                value={staffData.address}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
            <div>
              <label className={labelClass} htmlFor="salary">
                Monthly Pay (PKR)
              </label>
              <input
                id="salary"
                type="number"
                name="salary"
                placeholder="e.g. 35000"
                value={staffData.salary}
                onChange={handleChange}
                required
                className={inputClass}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ── Card: Professional Details ── */}
      <div className="border border-gray-200 rounded-xl overflow-hidden">
        {/* Card Header */}
        <div className="bg-[#215187] px-4 py-3">
          <p className="text-[12px] text-gray-100 font-medium uppercase tracking-wide">
            Professional Details
          </p>
        </div>

        {/* Card Body */}
        <div className="bg-white px-4 py-5 sm:px-6 sm:py-6">
          <form onSubmit={handleSubmit}>
            {/* Row — Hire Date, Role, Gender */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
              <div>
                <label className={labelClass} htmlFor="hire_date">
                  Date of Appointment
                </label>
                <input
                  id="hire_date"
                  type="date"
                  name="hire_date"
                  value={staffData.hire_date}
                  onChange={handleChange}
                  required
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass} htmlFor="role">
                  Assigned Role
                </label>
                <select
                  id="role"
                  name="role"
                  value={staffData.role}
                  onChange={handleChange}
                  required
                  className={inputClass}
                >
                  <option value="" disabled>
                    Select role
                  </option>
                  {roleData.map((r) => (
                    <option key={r.role_id} value={r.role_id}>
                      {r.role_name}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className={labelClass} htmlFor="gender">
                  Gender
                </label>
                <select
                  id="gender"
                  name="gender"
                  value={staffData.gender}
                  onChange={handleChange}
                  required
                  className={inputClass}
                >
                  <option value="" disabled>
                    Select gender
                  </option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-100 mb-5" />

            {/* Actions — identical to AddEditDispenser */}
            <div className="flex flex-col-reverse sm:flex-row items-center justify-center gap-3">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="w-full sm:w-auto px-5 py-3 text-[13px] font-medium text-gray-600 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition focus:outline-none focus:ring-2 focus:ring-gray-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading}
                className="w-full sm:w-auto px-6 py-3 text-[13px] font-medium text-white bg-[#2F6DB4] rounded-lg hover:bg-[#255A8C] transition focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-60 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              >
                {loading && (
                  <svg
                    className="w-3.5 h-3.5 animate-spin"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 0 1 8-8v8z"
                    />
                  </svg>
                )}
                {loading
                  ? "Saving..."
                  : id
                    ? "Update Staff"
                    : "Save and Continue"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddEditStaff;
